import { z } from "zod";
const interactionMomentIdSchema = z.uuid().brand();
function asInteractionMomentId(id) {
  return interactionMomentIdSchema.parse(id);
}
const facets = ["objection", "question", "buying_signal"];
function isFacet(value) {
  return facets.includes(value);
}
const sentiments = ["positive", "neutral", "negative"];
const agentHandlingValues = ["strong", "adequate", "weak"];
function mapInteractionMomentToAdminApp(moment) {
  return {
    id: moment.id,
    recording_id: moment.recording_id,
    data: moment.data,
    facet: moment.facet,
    sentiment: moment.sentiment,
    agent_handling: moment.agent_handling
  };
}
const interactionMomentEmotions = [
  "frustrated",
  "confused",
  "hesitant"
];
function isInteractionMomentEmotion(value) {
  return interactionMomentEmotions.includes(value);
}
export {
  agentHandlingValues,
  asInteractionMomentId,
  facets,
  interactionMomentEmotions,
  interactionMomentIdSchema,
  isFacet,
  isInteractionMomentEmotion,
  mapInteractionMomentToAdminApp,
  sentiments
};
//# sourceMappingURL=interactionMoment.js.map
